export const yearSelectOptions = Array.from(
  { length: 21 },
  (_, i) => new Date().getFullYear() - i,
).map((year) => ({ label: year.toString(), value: year.toString() }));

const today = new Date();
const currentMonth = today.getMonth();
const isDecember = currentMonth === 11;

// return the current year as a filling option only
// if we are at the last month of the current year
export const taxYearsOptions = Array.from({ length: 21 }, (_, i) =>
  isDecember ? today.getFullYear() - i : today.getFullYear() - i - 1,
).map((year) => ({ label: year.toString(), value: year.toString() }));
